function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 9.47212,
  cy: 9.47212,
  r: 9.47212,
  transform: "matrix(1 8.74228e-08 8.74228e-08 -1 0 19)",
  fill: "white"
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M12.3551 11.0263L9.23724 14.1442C9.09346 14.2931 9.0139 14.4925 9.01569 14.6994C9.01749 14.9064 9.10051 15.1044 9.24686 15.2507C9.39321 15.3971 9.59118 15.4801 9.79815 15.4819C10.0051 15.4837 10.2045 15.4041 10.3534 15.2604L14.8187 10.795C14.8922 10.7219 14.9506 10.635 14.9904 10.5392C15.0303 10.4434 15.0508 10.3407 15.0508 10.237C15.0508 10.1332 15.0303 10.0305 14.9904 9.93477C14.9506 9.839 14.8922 9.75204 14.8187 9.67891L10.3534 5.21359C10.2038 5.07336 10.0056 4.99681 9.80062 5.00014C9.59564 5.00347 9.4 5.08642 9.25509 5.23143C9.11018 5.37644 9.02737 5.57214 9.02419 5.77712C9.021 5.9821 9.09769 6.18028 9.23803 6.32973L12.3559 9.44763L4.78929 9.44763C4.57995 9.44763 4.37917 9.53079 4.23114 9.67882C4.08311 9.82686 3.99995 10.0276 3.99995 10.237C3.99995 10.4463 4.08311 10.6471 4.23114 10.7951C4.37917 10.9432 4.57995 11.0263 4.78929 11.0263L12.3551 11.0263Z",
  fill: "#030710"
});
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrowRight.4dd210106a5e50419b5d6d1e1e02a710.svg";
export { ForwardRef as ReactComponent };